import { ArrowLink } from "@components/ArrowLink"
import Footer from "@components/Footer"
import { useIntl } from "@components/Intl"
import { Box, Container } from "@components/Layout"
import { Gallery } from "@components/PhotoGallery"
import SEO from "@components/SEO"
import { ParagraphTitle, TitleL } from "@components/Typography"
import { getKontentImage } from "@lib/kontent/getKontentImage"
import { LookDetailPage } from "@lib/kontent/models-deprecated/look_detail_page"
import OtherLooks from "@screens/looks/detail/OtherLooks"
import React from "react"
import InThisLook from "./InThisLook"

interface Props {
  content: LookDetailPage
  otherLooks: LookDetailPage[]
  nextLookUrlSlug: string
}

const LookDetail: React.FC<Props> = ({
  content,
  otherLooks,
  nextLookUrlSlug,
}) => {
  const { messages } = useIntl()
  const galleryUrls = content.galleryImages.value.map((i) => i.url)
  const productCombinations = content.productCombinations.value
    .split(",")
    .map((t) => t.replace(" ", ""))

  const pathNl = `/nl/looks/${content.urlSlug.value}`
  const pathEn = `/en/looks/${content.urlSlug.value}`

  return (
    <>
      <SEO
        title={content.seoMetaTitle.value}
        description={content.seoMetaDescription.value}
        imageUrl={content.seoMetaImage.value[0]?.url}
        pathNl={pathNl}
        pathEn={pathEn}
      />
      <Container>
        <Box
          display={["none", "flex"]}
          justifyContent="space-between"
          pb="4"
          pt={120}
        >
          <ArrowLink href="/looks" as="/looks" variant={"arrow-left"}>
            Looks
          </ArrowLink>
          <ArrowLink
            href="/looks/[uid]"
            as={`/looks/${nextLookUrlSlug}`}
            variant={"arrow-right"}
          >
            {messages.lookDetail.nextLook}
          </ArrowLink>
        </Box>
        <Box
          display="grid"
          gridTemplateColumns={["1fr", "1fr", "1fr 1fr"]}
          pt={[85, 0]}
          gridColumnGap={[3, 3, 4]}
          gridRowGap={[4, 4, 0]}
        >
          {galleryUrls.length > 0 && (
            <Gallery
              images={galleryUrls.map((url) =>
                getKontentImage(url, { width: 600 })
              )}
              thumbnails={galleryUrls.map((url) =>
                getKontentImage(url, { width: 100 })
              )}
            />
          )}
          {productCombinations.length ? (
            <Box
              maxWidth={["27rem"]}
              width="100%"
              ml={["inherit", "inherit", "inherit", "auto"]}
            >
              <ParagraphTitle as="h1">
                {messages.lookDetail.jewelryInThisLook}
              </ParagraphTitle>
              <InThisLook ids={productCombinations} />
            </Box>
          ) : null}
        </Box>
      </Container>

      <Box width="100%" height="1px" bg="softGrey" my="5" />

      <Container>
        <Box textAlign="center">
          <TitleL>{messages.lookDetail.otherLooks}</TitleL>
        </Box>
        <OtherLooks items={otherLooks} />
      </Container>

      <Footer />
    </>
  )
}

export default LookDetail
